import Progress from 'redux-progress';
import { FETCH_RECOMMENDED } from 'modules/marketplace/recommended/duck/actions/fetch';

export default (state = Progress.none, action) => {
  switch (action.type) {
    case FETCH_RECOMMENDED:
      return action.progress;
    default:
      return state;
  }
};
